module.exports = __webpack_public_path__ + "static/media/IMG_1591.85150c3c.JPG";